module.exports = __webpack_public_path__ + "img/whatsapp.a8812701.svg";